import { Provider } from "react-redux";
import { store } from "@/Reducers/store.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

const queryClient = new QueryClient();

export const Wrapper = ({ children, ...props }) => {
    return (
        <Provider store={store} {...props}>
            <QueryClientProvider client={queryClient}>
                {children}
            </QueryClientProvider>
        </Provider>
    );
};
